import React from "react";
import { Heading } from "../../Heading";
import { ImgV2 } from "../../ImgV2";
export const PeopleCard = ({ imageUrl, personName, personPosition }) => (React.createElement("div", { className: "people-card-root" },
    React.createElement("div", { className: "people-card-root__image-container" },
        React.createElement(ImgV2, { src: imageUrl, alt: personName })),
    React.createElement("div", { className: "people-card-root__texts-container" },
        React.createElement(Heading, { design: "h4-lp" }, personName),
        React.createElement("p", { className: "p-regular" }, personPosition))));
